import { render, staticRenderFns } from "./Sync.vue?vue&type=template&id=31ca5560&"
import script from "./Sync.vue?vue&type=script&lang=ts&"
export * from "./Sync.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports